import store from 'store/store';
import { app } from 'store';
import { DocumentToast } from './DocumentToast';

export enum ToastTypes {
  PAN_TOOL_TOAST = 'panToolToast',
  DELETION_DIFFERENCE = 'deletionDifference',
  INSERTION_DIFFERENCE = 'insertionDifference',
  ANNOTATION_DIFFERENCE = 'annotationDifference',
  UNMATCHED_EMBEDDED_IMAGE = 'noMatchEmbeddedImage',
  FONT_METRICS_PASS = 'fontMetricsPass',
  FONT_METRICS_FAIL = 'fontMetricsFail',
  FONT_METRICS_PARTIAL_FAIL = 'fontMetricsPartialFail',
  COLOR_CHECK = 'colorCheck',
}

const toastEvents: Record<ToastTypes, Omit<DocumentToast, 'expired'>> = {
  [ToastTypes.PAN_TOOL_TOAST]: {
    type: 'info',
    message: 'Press and hold down the Space key to enable the pan tool.',
    duration: 10000,
    onDismiss: () =>
      store.dispatch(
        app.actions.updateUserPreferences({
          userPreferenceName: 'disablePanToolToast',
          value: true,
        }),
      ),
  },
  [ToastTypes.DELETION_DIFFERENCE]: {
    type: 'info',
    message: 'Oops! A deletion occurred. Please adjust the marker to show where the deletion was made.',
    duration: 10000,
  },
  [ToastTypes.INSERTION_DIFFERENCE]: {
    type: 'info',
    message: 'Oops! An insertion occurred. Please adjust the marker to show where the insertion should be referenced.',
    duration: 10000,
  },
  [ToastTypes.ANNOTATION_DIFFERENCE]: {
    type: 'info',
    message:
      'Oops! This annotation is not found. Please adjust the marker to show where the correction should be made.',
    duration: 10000,
  },
  [ToastTypes.UNMATCHED_EMBEDDED_IMAGE]: {
    type: 'info',
    message: 'Oops! This image is not found. Please adjust the marker to show where the image should be displayed.',
    duration: 10000,
  },
  [ToastTypes.FONT_METRICS_PASS]: {
    type: 'fontMetricsPass',
    message: 'Font size compliance confirmed! The entire document passes the minimum {fontPointSize}pt requirement.',
    duration: 10000,
  },
  [ToastTypes.FONT_METRICS_FAIL]: {
    type: 'fontMetricsFail',
    message: 'Font size compliance failed! The entire document fails the minimum {fontPointSize}pt requirement.',
    duration: 10000,
  },
  [ToastTypes.FONT_METRICS_PARTIAL_FAIL]: {
    type: 'fontMetricsFail',
    message:
      'Font size compliance failed! The document contains text that is below the minimum {fontPointSize}pt requirement.',
    duration: 10000,
  },
  [ToastTypes.COLOR_CHECK]: {
    type: 'escToExit',
    message: 'Select color points to inspect',
    infoMessage: 'Esc to exit',
  },
};

export default toastEvents;
